import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import UtilsPagos from '../../utils/payway/UtilsPagos'

const ModalAction = ({ proveedorName, buttons, callback, handleClose, format_type, offerid }) => {
  proveedorName = proveedorName ? proveedorName.replace(' ','') : '';

    const alerts = UtilsPagos.getUpsellAlerts(proveedorName, format_type, offerid);
    const asset = alerts.asset;
    const title = alerts.title;
    const content = alerts.content;
    const buttonCancel = alerts.buttonCancel;

    const actionButtons = buttons || [];

    const p = {
        content,
        buttons: [
            {
                content: buttonCancel,
                props: {
                    onClick: (e) => handleClose(e, callback),
                }
            },
            ...actionButtons
        ]
    }

    if (asset) p['asset'] = asset;
    if (title) p['title'] = title;

    return <ModalWrapper {...p} />;
}

export default withOnClose(ModalAction);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalAction.jsx